<div class="code-verification-wrapper general-wrapper">
	<section class="container">
		<div class="row justify-content-md-center">
			<div class="col-md-8 content-box">
				<app-code-verification></app-code-verification>
			</div>
		</div>
	</section>
</div>
